import React from 'react';

const items = [
  'Sproščati napetost v trebuščku in mišicah',
  'Omiliti kolike in izboljšati prebavo',
  'Spodbujati zdrav razvoj, rast in telesno zavedanje',
  'Krepiti imunski sistem',
  'Boljše spati in lažje prehajati med stanji budnosti in počitka',
  'Graditi samozavest, občutek lastne vrednosti in čustveno stabilnost',
];

const BabyBenefitsSection = () => (
  <section
    className="py-14 lg:py-20 relative overflow-hidden"
    data-testid="baby-benefits-section"
  >
    {/* Nova nežna ilustracija mamice z dojenčkom levo */}
<img
  src="/icons/vd_sub_mamica_dojencek.png"
  alt=""
  aria-hidden="true"
  className="
    hidden md:block
    absolute
    left-2 lg:left-6
    top-16 lg:top-20
    w-64 lg:w-[22rem]
    opacity-[0.15]
    pointer-events-none
    select-none
    z-0
  "
  data-testid="baby-benefits-decor"
/>

    <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

      {/* Naslov */}
      <div className="text-center mb-10">
        <h2
          className="font-serif text-2xl sm:text-3xl text-stone-800 font-bold"
          data-testid="baby-benefits-title"
        >
          Kaj masaža prinese tvojemu dojenčku?
        </h2>
      </div>

      {/* =========================================
          PROSTOROČNO NARISAN OKVIR
          ========================================= */}
      <div className="relative px-6 py-9 sm:px-9 lg:px-12 lg:py-11">

        {/* Nepravilen okvir kot svinčnik */}
        <svg
          aria-hidden="true"
          viewBox="0 0 1000 620"
          preserveAspectRatio="none"
          className="absolute inset-0 w-full h-full pointer-events-none"
        >
          {/* Glavna svinčnik črta */}
          <path
            d="
              M40 34
              C149 18, 293 28, 432 24
              C585 20, 730 30, 944 27
              C971 29, 981 49, 976 84
              C968 208, 982 338, 970 488
              C966 548, 953 586, 919 592
              C758 601, 615 589, 468 596
              C316 603, 175 588, 58 596
              C29 597, 19 570, 24 526
              C31 380, 17 243, 24 121
              C27 72, 25 46, 40 34
              Z
            "
            fill="none"
            stroke="rgba(111,91,65,0.42)"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {/* Druga nežna črta za ročno narisan učinek */}
          <path
            d="
              M46 39
              C163 29, 304 34, 439 31
              C597 26, 746 37, 938 33
              C963 34, 973 53, 969 87
              C965 216, 978 344, 965 482
              C961 542, 949 577, 914 585
              C764 592, 612 583, 464 590
              C311 596, 180 583, 64 590
              C37 591, 27 565, 31 522
              C36 374, 24 242, 31 126
              C34 79, 32 50, 46 39
              Z
            "
            fill="none"
            stroke="rgba(111,91,65,0.15)"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        {/* Vsebina */}
        <div className="relative z-10">
          <ul className="space-y-3">
            {items.map((text, i) => (
              <li
                key={i}
                className="
                  flex
                  items-start
                  gap-3
                  p-3
                  rounded-xl
                  hover:bg-violet-50/30
                  transition-colors
                "
                data-testid={`baby-benefit-${i}`}
              >
                <span className="flex-shrink-0 mt-2 w-1.5 h-1.5 bg-violet-800 rounded-full" />

                <p className="text-stone-700 text-[15px] leading-relaxed">
                  {text}
                </p>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  </section>
);

export default BabyBenefitsSection;